// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Ew-z","smallCardRow":"Fw-z","largeCardRow":"Gw-z","productSearchRow":"Hw-z","curatedRow":"Iw-z"};